var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagePeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.78556C22 10.4286 19.5432 12.5711 16.5126 12.5711C15.739 12.5711 15.0027 12.4315 14.3352 12.1796C13.8039 12.9799 12.9408 13.5744 11.1565 13.9968C11.0096 14.0316 10.9387 13.774 11.0666 13.6765C11.9759 12.984 12.4504 12.2978 12.6156 11.1548C11.6325 10.29 11.0252 9.09961 11.0252 7.78556C11.0252 5.14257 13.482 3 16.5126 3C19.5432 3 22 5.14257 22 7.78556Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.4C7.74264 15.4 8.75 14.415 8.75 13.2C8.75 11.985 7.74264 11 6.5 11C5.25736 11 4.25 11.985 4.25 13.2C4.25 14.415 5.25736 15.4 6.5 15.4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 22C2.50368 22 2 21.5075 2 20.9C2 18.4699 4.01472 16.5 6.5 16.5C8.98528 16.5 11 18.4699 11 20.9C11 21.5075 10.4963 22 9.875 22H3.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePeople);
export default __webpack_public_path__ + "static/media/message-people.fc4c7e76fd338c17b20aa60df7df9a90.svg";
export { ForwardRef as ReactComponent };